import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-notice\"><path d=\"M12.215 2a7 7 0 0 1 7 7v3.987l2.094 3.5A1 1 0 0 1 20.45 18H4a1 1 0 0 1-.853-1.522l2.068-3.374V9a7 7 0 0 1 7-7Zm0 2a5 5 0 0 0-4.996 4.783L7.215 9v4.668L5.785 16h12.902l-1.472-2.46V9a5 5 0 0 0-5-5Zm2.828 15.002a3.001 3.001 0 0 1-5.657 0h5.657Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol